import React from 'react';
import loadable from '@loadable/component';
import { Loading } from '../components/Loading';
import { UseUserQuery_user as UseUserQueryUser } from '../generated/types/UseUserQuery';
import { UserRewardStatus } from '../constants';
import { UserStatusLevel } from '../constants';
import { PageRoute } from './PageRoutes';
import { renderWithStatusCode } from './renderWithStatusCode';

const AccountPage = loadable(() => import('../pages/AccountPage'), { fallback: <Loading /> });

const AccountLoading = () => (
  <AccountPage>
    <Loading />
  </AccountPage>
);

const AccountSettings = loadable(() => import('../components/AccountSettings'), {
  fallback: <AccountLoading />
});
const AccountDesignerPreferences = loadable(
  () => import('../components/AccountDesignerPreferences'),
  {
    fallback: <AccountLoading />
  }
);
const AccountPaymentMethods = loadable(
  () => import('../components/PaymentMethod/AccountPaymentMethods'),
  {
    fallback: <AccountLoading />
  }
);
const AccountOrderHistory = loadable(() => import('../components/AccountOrderHistory'), {
  fallback: <AccountLoading />
});
const AccountOpenItems = loadable(() => import('../components/AccountOpenItems'), {
  fallback: <AccountLoading />
});
const AccountShippingAddresses = loadable(() => import('../components/AccountShippingAddresses'), {
  fallback: <AccountLoading />
});
const AccountShipments = loadable(() => import('../components/AccountShipments'), {
  fallback: <AccountLoading />
});
const AccountReturns = loadable(() => import('../components/AccountReturns'), {
  fallback: <AccountLoading />
});
const SiteCredits = loadable(() => import('../components/SiteCredits'), {
  fallback: <AccountLoading />
});
const AccountRewards = loadable(() => import('../components/AccountRewards'), {
  fallback: <AccountLoading />
});

export type AccountRoute = PageRoute & {
  label: string;
  hideFromNav?: (user: UseUserQueryUser) => boolean;
};

export const ACCOUNT_ROUTES: AccountRoute[] = [
  {
    key: 'AccountSettings',
    label: 'Settings',
    path: '/account/settings',
    component: renderWithStatusCode(AccountSettings),
    exact: true,
    pagetype: 'ACCOUNT'
  },
  {
    key: 'AccountDesignerPreferences',
    label: 'My Designer Preferences',
    path: '/account/preferences',
    component: renderWithStatusCode(AccountDesignerPreferences),
    exact: true,
    pagetype: 'ACCOUNT'
  },
  {
    key: 'AccountShippingAddresses',
    label: 'Shipping Addresses',
    path: '/account/addresses',
    component: renderWithStatusCode(AccountShippingAddresses),
    exact: true,
    pagetype: 'ACCOUNT'
  },
  {
    key: 'AccountPaymentMethods',
    label: 'Payment Methods',
    path: '/account/payment-methods',
    component: renderWithStatusCode(AccountPaymentMethods),
    exact: true,
    pagetype: 'ACCOUNT'
  },
  {
    key: 'AccountOrderHistory',
    label: 'Order History',
    path: '/account/orders',
    component: renderWithStatusCode(AccountOrderHistory),
    exact: true,
    pagetype: 'ACCOUNT'
  },
  {
    key: 'AccountOpenItems',
    label: 'Open Items',
    path: '/account/open-items',
    component: renderWithStatusCode(AccountOpenItems),
    exact: true,
    pagetype: 'ACCOUNT'
  },
  {
    key: 'AccountShipments',
    label: 'Shipments',
    path: '/account/shipments',
    component: renderWithStatusCode(AccountShipments),
    exact: true,
    pagetype: 'ACCOUNT'
  },
  {
    key: 'AccountReturns',
    label: 'Returns',
    path: '/account/returns',
    component: renderWithStatusCode(AccountReturns),
    exact: true,
    pagetype: 'ACCOUNT'
  },
  {
    key: 'AccountSiteCredits',
    label: 'Site Credits',
    path: '/account/credits',
    component: renderWithStatusCode(SiteCredits),
    exact: true,
    pagetype: 'ACCOUNT'
  },
  {
    key: 'AccountRewards',
    label: `M'O Rewards`,
    path: '/account/rewards',
    component: renderWithStatusCode(AccountRewards),
    exact: true,
    hideFromNav: user =>
      user.statusLevel === UserStatusLevel.Employee ||
      user.userLoyaltyStatus === UserRewardStatus.NoAccess,
    pagetype: 'ACCOUNT'
  }
];
